export const content = {
  // ================================================================
  // 한국어 (Korean)
  // ================================================================
  ko: {
    // --- 헤더 ---
    headerNav1: "데이터 분석",
    headerNav2: "개발자센터",
    headerNav3: "문의하기",

    // --- 히어로 섹션 ---
    heroTitle: (
      <>
        공간데이터와 인공지능의 융합으로<br />
        도시·산업의 의사결정을 고도화합니다
      </>
    ),
    heroSubtitle: (
      <>
        ㈜스페이셜코어는 공간데이터와 인공지능을 결합한 Spatial AI 전문기업으로, 인공지능 학습용 데이터 구축·정제 및 품질관리,<br />
        공간정보 활용 서비스 컨설팅과 교육, 스마트관광 데이터 분석 및 공간지능 AI 연구개발을 수행합니다.
      </>
    ),
    // --- Mission · Vision ---
    missionTitle: "Mission · Vision",
    missionSubtitle: (
      <>
        Spatial AI로 <strong>사람과 공간이 상호 학습하는 지능형 환경</strong>을 만듭니다.
        <br />
        데이터와 AI가 연결된 공간생태계를 통해 도시·관광·산업의 디지털 전환을 주도합니다.
      </>
    ),
    // --- Future Direction ---
    futureTitle: "Future Direction",
    futureCard1: "Edge-Cloud 연계 자율 인식, 경로 최적화, 중앙 관제 기술 고도화",
    futureCard2: "장소의 의미 기반 데이터 수집·분석·AI 학습 체계 구축으로 공간의 맥락적 이해 확장",
    futureCard3: "이동, 체류, 감정 신호 기반 공간 경험 분석 및 예측 모델 개발",
    futureCard4: "데이터 품질·표준·윤리·투명성 중심의 책임형 AI 운영 체계 확립",
    // --- 프로토타입 ---
    protoTitle: "Spatial AI 활용 제품·서비스 프로토타입",
    protoSubtitle: "스페이셜코어는 도시, 관광, 산업 데이터를 실시간으로 해석하고 예측하는 다양한 프로토타입을 연구하고 있습니다.",
    // --- Core Business Areas ---
    coreTitle: "Core Business Areas",
    coreCard1Title: "데이터 연구·개발",
    coreCard1Content: "GNN/그래프 분석·시계열·추천모델을 활용한 공간 의미 해석, 수요 예측, 경로 의사결정 등 공간지능 AI 모델 연구 및 사용화",
    coreCard2Title: "스마트관광 서비스",
    coreCard2Content: "관광데이터 분석, 방문 코스 예측·추천, 체류시간·혼잡도 분석 등 스마트관광 도시·지역 맞춤형 솔루션 개발",
    coreCard3Title: "학습데이터 구축 및 품질관리",
    coreCard3Content: "공공·민간 공간데이터의 수집·라벨링·정제·가공 및 품질관리 수행, AI 학습용 데이터셋 표준화 및 검증체계 구축",
    coreCard4Title: "데이터 유통 플랫폼",
    coreCard4Content: "공간데이터의 수집·정제·카탈로그·거버넌스를 지원하는 데이터 유통·활용 플랫폼 구축 및 API 서비스 제공",
    coreCard5Title: "XR·Web Platform",
    coreCard5Content: "XR, WebGL, Three.js를 활용한 3D 공간 데이터 시각화 및 실시간 분석·대시보드 개발",
    coreCard6Title: "서비스 컨설팅 및 교육",
    coreCard6Content: "공공·민간기관 대상 공간데이터 활용전략 수립, AI 서비스 도입 컨설팅 및 산업 맞춤형 전문 교육 운영",
    coreCard7Title: "R&D 및 생태계 조성",
    coreCard7Content: "Edge-Cloud 연계 자율 위치 인식, 자율 이동체 경로 최적화 등 특허 기반 핵심 기술의 심화 연구 및 상용화 연계",
    // --- History ---
    historyTitle: "History",
    historyDesc1: "(주)스페이셜코어 설립",
    historyDesc2: "한국데이터산업진흥원 데이터 공급기업 등록",
    historyDesc3: "연구개발전담부서 설치",
    historyDesc4: "벤처기업 인증(혁신성장유형)",
    historyDesc5: "인공지능산업융합사업단 AI시제품서비스제작지원사업 선정",
    historyDesc6: "과학기술정보통신부 데이터사업자 신고",
    historyDesc7: "이상행동 감지 지능형 무인 비행체 관리시스템 특허출원",
    historyDesc8: "한국탄소산업진흥원 창업도약패키지(일반형) 창업기업 선정",
    historyDesc9: "ISO 14001 인증(데이터베이스 및 AI서비스)",
    historyDesc10: "2024년 창업성장기술개발사업 디딤돌R&D 선정",
    historyDesc11: "Spatial AI 기반 자율주행 배송용 로봇 관제시스템 특허출원",
    historyDesc12: "서울과학기술대학교 글로벌 기업 협업 프로그램 선정",
    historyDesc13: "Spatial AI 기반 Edge-Cloud 시스템 관련 특허출원",
    historyDesc14: "Taiwan Innotech Expo Invention Copetition / Silver Medal",
    // --- ESG ---
    esgTitle: "ESG",
    esgSubtitle: (
      <>
        스페이셜코어는 기술의 목표를 ‘편리함’보다 ‘지속가능성’에 두고 있습니다. 우리는 Spatial AI를 통해 도시의 에너지 효율을 높이고,<br /> 관광지의 환경 부담을 줄이며, 지역사회가 데이터를 기반으로 공정하고 균형 있게 성장할 수 있도록 지원합니다.
      </>
    ),
    esgCard1Title: "친환경 데이터 인프라",
    esgCard1Content: "불필요한 연산과 서버 부하를 최소화하는 Edge-Cloud 구조 설계",
    esgCard2Title: "지속가능 관광",
    esgCard2Content: "공간데이터와 관광 분석을 기반으로 지역 방문객을 유입시키고, 지역 상권의 기회와 연결을 확장",
    esgCard3Title: "지역 비즈니스 성장",
    esgCard3Content: "공간데이터 기반 방문 패턴 예측을 통해 지역 간 방문을 효율적으로 분산하고, 균형 있는 관광 성장을 유도",
    // --- Contact us ---
    contactTitle: "Contact us",
    contactSubtitle: "프로젝트·컨설팅·교육에 대한 대한 목표, 데이터 현황, 희망 일정을 알려주시면 맞춤형 제안을 제공해 드립니다.",
    contactFormName: "성함",
    contactFormEmail: "이메일",
    contactFormCompany: "기관/회사명",
    contactFormMessage: "문의내용",
    contactFormButton: "보내기",

    // --- 푸터 ---
    footerCompany: "주식회사 스페이셜코어",
    footerLink1: "이용약관",
    footerLink2: "개인정보처리방침",
    footerLink3: "저작권정책",

    // --- Map 페이지 ---
    mapSpatialInfo: "공간정보",
    mapSpatialInfoDesc: "공간 관련 정보를 제공합니다.",
    mapDirections: "길찾기",
    mapDirectionsDesc: "출발지와 목적지를 설정하세요.",
    mapSearch: "위치검색",
    mapSearchDesc: "장소를 검색할 수 있습니다.",
    mapBoundaryTab: "행정경계",
    mapDataTab: "데이터",
    mapKeywordSearch: "데이터 검색",
    mapClearAll: "전체 해제",
    mapApply: "적용하기",
    mapStartPlaceholder: "출발지 입력",
    mapEndPlaceholder: "도착지 입력",
    mapSearchPlaceholder: "주소 검색",
    mapRouteBtn: "경로찾기",
    mapDetailRoute: "상세 경로",
    mapStart: "출발",
    mapEnd: "도착",
    mapSelectStartEnd: "출발지와 도착지를 모두 입력해주세요.",
    mapRouteNotFound: "경로를 찾을 수 없습니다.",
    mapRouteError: "경로를 찾는 데 실패했습니다",
    mapSearchError: "검색에 실패했습니다",
    mapBoundarySido: "시도경계",
    mapBoundarySigungu: "시군구경계",
    mapBoundaryBeopjeongdong: "법정동경계",
    mapBoundaryHaengjeongdong: "행정동경계",
    mapSpatialDataPopulationAge: "연령별 거주인구",
    mapSpatialDataWorkplacePopulation: "연령별 직장인구",
    mapSpatialDataCulturalFacilities: "문화 시설",
    mapSpatialDataAge0_19: "0-19세",
    mapSpatialDataAge20_39: "20-39세",
    mapSpatialDataAge40_59: "40-59세",
    mapSpatialDataAge60Plus: "60세 이상",
    mapSpatialDataWork20_29: "20-29세",
    mapSpatialDataWork30_39: "30-39세",
    mapSpatialDataWork40Plus: "40세 이상",
    mapSpatialDataLibraries: "도서관",
    mapSpatialDataMuseums: "박물관",
    mapSpatialDataAll: "전체",
    mapSpatialDataDescPopulation: "전국 시도별 연령대별 거주인구 분포 데이터입니다.",
    mapSpatialDataDescWorkplace: "전국 시도별 연령대별 직장인구 분포 데이터입니다.",
    mapSpatialDataDescCultural: "전국 시도별 문화시설 분포 데이터입니다.",
    mapSpatialDataBusStops: "버스 정류장",
    mapSpatialDataDescBusStops: "전국 시도별 버스 정류장 위치 데이터입니다.",
    mapSpatialDataHospitality: "숙박 시설",
    mapSpatialDataDescHospitality: "전국 시도별 숙박 시설 분포 데이터입니다.",

    // --- DeveloperCenter 페이지 ---
    devCenterTitle: "개발자센터",
    devCenterLanding: "랜딩 페이지",
    devCenterMapAPI: "지도 API",
    devCenterSpatialAPI: "공간정보 API",
    devCenterRoutingAPI: "길찾기 API",
    devCenterSearchAPI: "위치검색 API",
    devCenterGettingStarted: "시작하기 가이드",
    devCenterPricing: "가격 정책",
    devCenterCopy: "복사",
    devCenterCopied: "복사됨!",
    devCenterLandingTitle: "공간정보 API로 위치 기반 서비스를 쉽게 구축하세요",
    devCenterLandingIntro: "SpatialCore API를 사용하여 강력한 위치 기반 애플리케이션을 빠르게 개발할 수 있습니다.",
    devCenterLandingIntro2: "별도 설치 없이 API 키만으로 즉시 사용 가능한 완전관리형(Managed) SaaS 서비스입니다.",
    devCenterFeatureMap: "지도 렌더링 API",
    devCenterFeatureMapDesc: "고성능 지도 표시 및 다양한 커스터마이징 옵션을 제공합니다. 마커, 폴리라인, 폴리곤 등 다양한 오버레이를 지원하며, 이벤트 핸들링을 통한 인터랙티브한 지도 구현이 가능합니다.",
    devCenterFeatureBoundary: "행정경계 데이터 API",
    devCenterFeatureBoundaryDesc: "전국 행정구역 경계 데이터를 실시간으로 조회할 수 있습니다. 시도, 시군구, 읍면동 단위로 조회가 가능하며, GeoJSON 형식으로 제공되어 다양한 GIS 도구와 호환됩니다.",
    devCenterFeatureRouting: "길찾기/경로 탐색 API",
    devCenterFeatureRoutingDesc: "자동차, 대중교통, 도보 경로 탐색과 실시간 교통정보를 제공합니다. 다중 경유지 지원 및 경로 최적화 기능으로 효율적인 경로 계획을 수립할 수 있습니다.",
    devCenterFeatureSearch: "위치검색/지오코딩 API",
    devCenterFeatureSearchDesc: "주소 검색, 좌표 변환, POI 검색 등 다양한 위치 검색 기능을 지원합니다. 실시간 자동완성 기능으로 사용자 경험을 향상시킬 수 있습니다.",
    devCenterFeaturesTitle: "주요 특징",
    devCenterFeature1: "빠른 응답 속도",
    devCenterFeature1Desc: "고성능 서버 인프라로 빠른 API 응답 시간을 보장합니다.",
    devCenterFeature2: "확장 가능한 아키텍처",
    devCenterFeature2Desc: "대용량 트래픽에도 안정적인 서비스를 제공합니다.",
    devCenterFeature3: "상세한 문서",
    devCenterFeature3Desc: "완벽한 API 문서와 코드 예제를 제공합니다.",
    devCenterFeature4: "다양한 SDK 지원",
    devCenterFeature4Desc: "JavaScript, Python, Java 등 다양한 언어의 SDK를 제공합니다.",
    devCenterFeature5: "실시간 지원",
    devCenterFeature5Desc: "기술 지원팀이 실시간으로 도움을 드립니다.",
    devCenterQuickStart: "빠른 시작 가이드",
    devCenterMapAPITitle: "지도 API",
    devCenterMapAPIDesc: "지도를 표시하고 마커, 오버레이를 추가하며 커스터마이징할 수 있는 강력한 지도 API입니다.",
    devCenterSpatialAPITitle: "공간정보 API",
    devCenterSpatialAPIDesc: "행정구역 경계 데이터와 지역별 통계 정보를 제공하는 공간정보 API입니다.",
    devCenterRoutingAPITitle: "길찾기 API",
    devCenterRoutingAPIDesc: "최적의 경로를 탐색하고 실시간 교통정보를 반영하는 길찾기 API입니다.",
    devCenterSearchAPITitle: "위치검색 API",
    devCenterSearchAPIDesc: "주소 검색, 좌표 변환, POI 검색 등 다양한 위치 검색 기능을 제공하는 API입니다.",
    devCenterGettingStartedTitle: "시작하기 가이드",
    devCenterPricingTitle: "가격 정책",
    devCenterPricingDesc: "SpatialCore는 다양한 요구사항에 맞는 유연한 가격 정책을 제공합니다.",
    devCenterPricingCustom: "맞춤형 가격 문의",
    devCenterAPIDocs: "API 문서",
    devCenterGuide: "가이드",
    devCenterGettingStartedDesc: "SpatialCore API를 빠르게 시작하는 방법을 알아보세요.",
    devCenterAPIKeyTitle: "API 키 발급",
    devCenterAPIKeyDesc: "API 키 발급은 문의하기를 통해 요청해 주세요. 담당자가 신속히 발급을 도와드립니다.",
    devCenterSDKInstall: "SDK 설치",
    devCenterMapInit: "지도 초기화",
    devCenterAddMarker: "마커 추가",
    devCenterFullExample: "전체 예제",
    devCenterFullExampleDesc: "다음은 완전한 HTML 페이지 예제입니다:",
    devCenterNextSteps: "다음 단계",
    devCenterFAQ: "자주 묻는 질문",
    devCenterFAQKey: "API 키는 어디서 발급받나요?",
    devCenterFAQKeyAnswer: "API 키는 문의하기를 통해 요청하시면 발급을 도와드립니다.",
    devCenterFAQBrowser: "어떤 브라우저를 지원하나요?",
    devCenterFAQBrowserAnswer: "Chrome, Firefox, Safari, Edge 등 최신 브라우저를 모두 지원합니다. IE11은 제한적으로 지원됩니다.",
    devCenterFAQMobile: "모바일 앱에서도 사용할 수 있나요?",
    devCenterFAQMobileAnswer: "네, React Native, Flutter, 네이티브 iOS/Android 앱에서도 사용 가능한 SDK를 제공합니다.",
    devCenterPricingContactDesc: "귀하의 프로젝트 규모와 요구사항에 맞는 최적의 플랜을 제안해드립니다.",
    devCenterContactUs: "직접 문의하기",
    devCenterMapDisplayControl: "지도 표시 및 컨트롤",
    devCenterMapDisplayControlDesc: "기본 지도를 표시하고 확대/축소, 이동 등의 컨트롤을 추가할 수 있습니다.",
    devCenterKeyParams: "주요 파라미터",
    devCenterAPIKeyParam: "발급받은 API 키",
    devCenterContainerParam: "지도를 표시할 HTML 엘리먼트 ID",
    devCenterCenterParam: "초기 중심 좌표 [경도, 위도]",
    devCenterZoomParam: "초기 줌 레벨 (1-18)",
    devCenterControlsParam: "표시할 컨트롤 옵션",
    devCenterOverlayAdd: "마커/오버레이 추가",
    devCenterOverlayAddDesc: "지도 위에 마커, 폴리라인, 폴리곤 등의 오버레이를 쉽게 추가할 수 있습니다.",
    devCenterStyleCustom: "지도 스타일 커스터마이징",
    devCenterStyleCustomDesc: "다양한 지도 스타일 테마를 제공하며, 커스텀 스타일도 적용할 수 있습니다.",
    devCenterEventHandling: "이벤트 핸들링",
    devCenterEventHandlingDesc: "클릭, 드래그, 줌 등 다양한 사용자 이벤트를 처리할 수 있습니다.",
    devCenterBoundaryQuery: "행정구역 경계 데이터 조회",
    devCenterBoundaryQueryDesc: "시도, 시군구, 읍면동 등 각 행정구역의 경계 데이터를 조회할 수 있습니다.",
    devCenterAPIEndpoint: "API 엔드포인트",
    devCenterStatistics: "지역별 통계 데이터",
    devCenterStatisticsDesc: "각 행정구역별 인구, 면적 등 다양한 통계 데이터를 제공합니다.",
    devCenterGeoJSON: "GeoJSON 형식 지원",
    devCenterGeoJSONDesc: "표준 GeoJSON 형식으로 데이터를 제공하여 다양한 GIS 도구와 호환됩니다.",
    devCenterRouteTypes: "자동차/대중교통/도보 경로",
    devCenterRouteTypesDesc: "다양한 이동 수단에 맞는 최적 경로를 제공합니다.",
    devCenterTrafficInfo: "실시간 교통정보 반영",
    devCenterTrafficInfoDesc: "실시간 교통 상황을 반영하여 가장 빠른 경로를 제안합니다.",
    devCenterWaypoints: "다중 경유지 지원",
    devCenterWaypointsDesc: "여러 경유지를 거치는 경로도 계산할 수 있습니다.",
    devCenterRouteDetails: "예상 소요시간/거리",
    devCenterRouteDetailsDesc: "각 경로의 예상 소요시간과 거리 정보를 제공합니다.",
    devCenterGeocoding: "주소 검색 (지오코딩)",
    devCenterGeocodingDesc: "주소를 입력하면 해당 위치의 좌표를 반환합니다.",
    devCenterReverseGeocoding: "좌표 → 주소 변환 (역지오코딩)",
    devCenterReverseGeocodingDesc: "좌표를 입력하면 해당 위치의 주소 정보를 반환합니다.",
    devCenterPOI: "POI(관심지점) 검색",
    devCenterPOIDesc: "음식점, 주유소, 편의점 등 다양한 관심지점을 검색할 수 있습니다.",
    devCenterMapAPIUse: "문서에서 더 자세한 기능을 확인하세요.",
    devCenterSpatialAPIUse: "로 행정구역 데이터를 활용하세요.",
    devCenterRoutingAPIUse: "로 경로 탐색 기능을 추가하세요.",
    devCenterSearchAPIUse: "로 주소 검색 기능을 구현하세요.",
  },

  // ================================================================
  // 영어 (English)
  // ================================================================
  en: {
    // --- Header ---
    headerNav1: "Data Analysis",
    headerNav2: "Developer Center",
    headerNav3: "Contact us",

    // --- Hero Section ---
    heroTitle: (
      <>
        Advancing Urban and Industrial Decision-Making
        through the Convergence of Geospatial Data and AI
      </>
    ),
    heroSubtitle: (
      <>
        Spatial Core Inc. is a Spatial AI specialist company combining geospatial data and artificial intelligence, performing AI training data construction, refinement, and quality control,
        as well as geospatial information service consulting, education, smart tourism data analysis, and Spatial AI R&D.
      </>
    ),
    // --- Mission · Vision ---
    missionTitle: "Mission · Vision",
    missionSubtitle: (
      <>
        Creating an intelligent environment where <strong>humans and spaces learn from each other</strong> through Spatial AI.
        Leading the digital transformation of cities, tourism, and industry through a data and AI-connected spatial ecosystem.
      </>
    ),
    // --- Future Direction ---
    futureTitle: "Future Direction",
    futureCard1: "Advanced Edge-Cloud linked autonomous perception, route optimization, and central control technology.",
    futureCard2: "Establishing a place-meaning-based system for data collection, analysis, and AI training to expand the contextual understanding of space.",
    futureCard3: "Developing models for analyzing and predicting spatial experiences based on movement, dwell time, and emotional signals.",
    futureCard4: "Establishing a responsible AI operation system centered on data quality, standards, ethics, and transparency.",
    // --- Prototype ---
    protoTitle: "Spatial AI Application Products & Service Prototypes",
    protoSubtitle: "Spatial Core researches various prototypes that interpret and predict city, tourism, and industrial data in real-time.",
    // --- Core Business Areas ---
    coreTitle: "Core Business Areas",
    coreCard1Title: "Data Research & Development",
    coreCard1Content: "Research and commercialization of Spatial AI models such as spatial semantic analysis, demand forecasting, and route decision-making using GNN/graph analysis, time-series, and recommendation models.",
    coreCard2Title: "Smart Tourism Service",
    coreCard2Content: "Development of customized smart tourism solutions for cities and regions, including tourism data analysis, visit course prediction/recommendation, and dwell time/congestion analysis.",
    coreCard3Title: "Training Data Construction & Quality Management",
    coreCard3Content: "Performing collection, labeling, refinement, and processing of public/private geospatial data and quality control; standardizing AI training datasets and building verification systems.",
    coreCard4Title: "Data Distribution Platform",
    coreCard4Content: "Building a data distribution and utilization platform that supports the collection, refinement, cataloging, and governance of geospatial data, and providing API services.",
    coreCard5Title: "XR·Web Platform",
    coreCard5Content: "3D geospatial data visualization and real-time analysis/dashboard development using XR, WebGL, and Three.js.",
    coreCard6Title: "Service Consulting & Education",
    coreCard6Content: "Establishing geospatial data utilization strategies for public/private institutions, consulting on AI service adoption, and operating industry-specific professional education.",
    coreCard7Title: "R&D and Ecosystem Creation",
    coreCard7Content: "In-depth research and commercialization linkage of core patent-based technologies such as Edge-Cloud linked autonomous positioning and autonomous mobile entity route optimization.",
    // --- History ---
    historyTitle: "History",
    historyDesc1: "Spatial Core Inc. Established",
    historyDesc2: "Registered as a Data Provider with the Korea Data Industry Agency (K-DATA)",
    historyDesc3: "R&D Center Established",
    historyDesc4: "Venture Business Certification (Innovative Growth Type)",
    historyDesc5: "Selected for AI Prototype Service Production Support Project by the AI Industry Convergence Project Group",
    historyDesc6: "Registered as a Data Business with the Ministry of Science and ICT",
    historyDesc7: "Patent Application for Intelligent UAV Management System for Abnormal Behavior Detection",
    historyDesc8: "Selected for Start-up Leap Package (General Type) by the Korea Carbon Industry Promotion Agency",
    historyDesc9: "ISO 14001 Certification (Database and AI Service)",
    historyDesc10: "Selected for 2024 Start-up Growth Technology Development Program (Stepping Stone R&D)",
    historyDesc11: "Patent Application for Spatial AI-based Autonomous Delivery Robot Control System",
    historyDesc12: "Selected for Global Corporate Collaboration Program with Seoul National University of Science and Technology",
    historyDesc13: "Patent Application for Spatial AI-based Edge-Cloud System",
    historyDesc14: "Taiwan Innotech Expo Invention Competition / Silver Medal",
    // --- ESG ---
    esgTitle: "ESG",
    esgSubtitle: (
      <>
        Spatial Core places the goal of its technology on 'sustainability' rather than 'convenience'. Through Spatial AI, we increase the energy efficiency of cities, reduce the environmental burden on tourist destinations, and support communities to grow fairly and balancedly based on data.
      </>
    ),
    esgCard1Title: "Eco-Friendly Data Infrastructure",
    esgCard1Content: "Edge-Cloud architecture design that minimizes unnecessary computation and server load.",
    esgCard2Title: "Sustainable Tourism",
    esgCard2Content: "Attracting local visitors based on geospatial data and tourism analysis, expanding opportunities and connections for local businesses.",
    esgCard3Title: "Regional Business Growth",
    esgCard3Content: "Efficiently distributing visits between regions through geospatial data-based visit pattern prediction, inducing balanced tourism growth.",
    // --- Contact us ---
    contactTitle: "Contact us",
    contactSubtitle: "Please inform us of your goals, data status, and desired schedule for projects, consulting, or education, and we will provide a customized proposal.",
    contactFormName: "Name",
    contactFormEmail: "Email",
    contactFormCompany: "Organization/Company",
    contactFormMessage: "Message",
    contactFormButton: "Submit",

    // --- Footer ---
    footerCompany: "Spatial Core Inc.",
    footerLink1: "Terms of Service",
    footerLink2: "Privacy Policy",
    footerLink3: "Copyright Policy",

    // --- Map Page ---
    mapSpatialInfo: "Spatial Information",
    mapSpatialInfoDesc: "Provides spatial-related information.",
    mapDirections: "Directions",
    mapDirectionsDesc: "Set your departure and destination.",
    mapSearch: "Location Search",
    mapSearchDesc: "Search for places.",
    mapBoundaryTab: "Administrative Boundaries",
    mapDataTab: "Data",
    mapKeywordSearch: "Keyword Search",
    mapClearAll: "Clear All",
    mapApply: "Apply",
    mapStartPlaceholder: "Enter departure",
    mapEndPlaceholder: "Enter destination",
    mapSearchPlaceholder: "Search address",
    mapRouteBtn: "Find Route",
    mapDetailRoute: "Detailed Route",
    mapStart: "Start",
    mapEnd: "End",
    mapSelectStartEnd: "Please enter both departure and destination.",
    mapRouteNotFound: "Route not found.",
    mapRouteError: "Failed to find route",
    mapSearchError: "Search failed",
    mapBoundarySido: "Province Boundaries",
    mapBoundarySigungu: "City/County Boundaries",
    mapBoundaryBeopjeongdong: "Legal District Boundaries",
    mapBoundaryHaengjeongdong: "Administrative District Boundaries",
    mapSpatialDataPopulationAge: "Resident Population by Age",
    mapSpatialDataWorkplacePopulation: "Workplace Population by Age",
    mapSpatialDataCulturalFacilities: "Cultural Facilities",
    mapSpatialDataAge0_19: "0-19 years",
    mapSpatialDataAge20_39: "20-39 years",
    mapSpatialDataAge40_59: "40-59 years",
    mapSpatialDataAge60Plus: "60+ years",
    mapSpatialDataWork20_29: "20-29 years",
    mapSpatialDataWork30_39: "30-39 years",
    mapSpatialDataWork40Plus: "40+ years",
    mapSpatialDataLibraries: "Libraries",
    mapSpatialDataMuseums: "Museums",
    mapSpatialDataAll: "All",
    mapSpatialDataDescPopulation: "Nationwide resident population distribution data by age group by province.",
    mapSpatialDataDescWorkplace: "Nationwide workplace population distribution data by age group by province.",
    mapSpatialDataDescCultural: "Nationwide cultural facility distribution data by province.",
    mapSpatialDataBusStops: "Bus Stops",
    mapSpatialDataDescBusStops: "Nationwide bus stop location data by province.",
    mapSpatialDataHospitality: "Accommodation Facilities",
    mapSpatialDataDescHospitality: "Nationwide accommodation facility distribution data by province.",

    // --- DeveloperCenter Page ---
    devCenterTitle: "Developer Center",
    devCenterLanding: "Landing Page",
    devCenterMapAPI: "Map API",
    devCenterSpatialAPI: "Spatial Information API",
    devCenterRoutingAPI: "Routing API",
    devCenterSearchAPI: "Location Search API",
    devCenterGettingStarted: "Getting Started Guide",
    devCenterPricing: "Pricing",
    devCenterCopy: "Copy",
    devCenterCopied: "Copied!",
    devCenterLandingTitle: "Build location-based services easily with Spatial Information API",
    devCenterLandingIntro: "You can quickly develop powerful location-based applications using SpatialCore API.",
    devCenterLandingIntro2: "It is a fully managed SaaS service that can be used immediately with just an API key without separate installation.",
    devCenterFeatureMap: "Map Rendering API",
    devCenterFeatureMapDesc: "Provides high-performance map display and various customization options. Supports various overlays such as markers, polylines, and polygons, and enables interactive map implementation through event handling.",
    devCenterFeatureBoundary: "Administrative Boundary Data API",
    devCenterFeatureBoundaryDesc: "You can query nationwide administrative boundary data in real-time. Available by province, city/county, and town/village units, and provided in GeoJSON format, compatible with various GIS tools.",
    devCenterFeatureRouting: "Routing/Path Search API",
    devCenterFeatureRoutingDesc: "Provides car, public transportation, and walking route search with real-time traffic information. Supports multiple waypoints and route optimization for efficient route planning.",
    devCenterFeatureSearch: "Location Search/Geocoding API",
    devCenterFeatureSearchDesc: "Supports various location search features such as address search, coordinate conversion, and POI search. Improves user experience with real-time autocomplete functionality.",
    devCenterFeaturesTitle: "Key Features",
    devCenterFeature1: "Fast Response Speed",
    devCenterFeature1Desc: "Ensures fast API response time with high-performance server infrastructure.",
    devCenterFeature2: "Scalable Architecture",
    devCenterFeature2Desc: "Provides stable service even under high traffic loads.",
    devCenterFeature3: "Detailed Documentation",
    devCenterFeature3Desc: "Provides complete API documentation and code examples.",
    devCenterFeature4: "Multi-SDK Support",
    devCenterFeature4Desc: "Provides SDKs for various languages including JavaScript, Python, Java.",
    devCenterFeature5: "Real-time Support",
    devCenterFeature5Desc: "Technical support team helps you in real-time.",
    devCenterQuickStart: "Quick Start Guide",
    devCenterMapAPITitle: "Map API",
    devCenterMapAPIDesc: "A powerful map API that allows you to display maps, add markers and overlays, and customize them.",
    devCenterSpatialAPITitle: "Spatial Information API",
    devCenterSpatialAPIDesc: "A spatial information API that provides administrative boundary data and regional statistics.",
    devCenterRoutingAPITitle: "Routing API",
    devCenterRoutingAPIDesc: "A routing API that searches for optimal routes and reflects real-time traffic information.",
    devCenterSearchAPITitle: "Location Search API",
    devCenterSearchAPIDesc: "An API that provides various location search features such as address search, coordinate conversion, and POI search.",
    devCenterGettingStartedTitle: "Getting Started Guide",
    devCenterPricingTitle: "Pricing",
    devCenterPricingDesc: "SpatialCore offers flexible pricing policies to meet various requirements.",
    devCenterPricingCustom: "Custom Pricing Inquiry",
    devCenterAPIDocs: "API Documentation",
    devCenterGuide: "Guide",
    devCenterGettingStartedDesc: "Learn how to quickly get started with SpatialCore API.",
    devCenterAPIKeyTitle: "API Key Issuance",
    devCenterAPIKeyDesc: "Please request an API key through the contact form. Our team will assist you promptly.",
    devCenterSDKInstall: "SDK Installation",
    devCenterMapInit: "Map Initialization",
    devCenterAddMarker: "Add Marker",
    devCenterFullExample: "Complete Example",
    devCenterFullExampleDesc: "Here is a complete HTML page example:",
    devCenterNextSteps: "Next Steps",
    devCenterFAQ: "Frequently Asked Questions",
    devCenterFAQKey: "Where can I get an API key?",
    devCenterFAQKeyAnswer: "You can request an API key through the contact form and we will assist you with issuance.",
    devCenterFAQBrowser: "Which browsers are supported?",
    devCenterFAQBrowserAnswer: "We support all modern browsers including Chrome, Firefox, Safari, and Edge. IE11 is supported with limitations.",
    devCenterFAQMobile: "Can I use it in mobile apps?",
    devCenterFAQMobileAnswer: "Yes, we provide SDKs for React Native, Flutter, and native iOS/Android apps.",
    devCenterPricingContactDesc: "We will propose the optimal plan tailored to your project scale and requirements.",
    devCenterContactUs: "Contact Us",
    devCenterMapDisplayControl: "Map Display and Controls",
    devCenterMapDisplayControlDesc: "Display a basic map and add controls such as zoom and pan.",
    devCenterKeyParams: "Key Parameters",
    devCenterAPIKeyParam: "Issued API key",
    devCenterContainerParam: "HTML element ID to display the map",
    devCenterCenterParam: "Initial center coordinates [longitude, latitude]",
    devCenterZoomParam: "Initial zoom level (1-18)",
    devCenterControlsParam: "Control options to display",
    devCenterOverlayAdd: "Marker/Overlay Addition",
    devCenterOverlayAddDesc: "Easily add overlays such as markers, polylines, and polygons on the map.",
    devCenterStyleCustom: "Map Style Customization",
    devCenterStyleCustomDesc: "Provides various map style themes and allows custom styles to be applied.",
    devCenterEventHandling: "Event Handling",
    devCenterEventHandlingDesc: "Handle various user events such as clicks, drags, and zoom.",
    devCenterBoundaryQuery: "Administrative Boundary Data Query",
    devCenterBoundaryQueryDesc: "Query boundary data for each administrative district such as provinces, cities/counties, and towns/villages.",
    devCenterAPIEndpoint: "API Endpoint",
    devCenterStatistics: "Regional Statistics Data",
    devCenterStatisticsDesc: "Provides various statistics data such as population and area for each administrative district.",
    devCenterGeoJSON: "GeoJSON Format Support",
    devCenterGeoJSONDesc: "Provides data in standard GeoJSON format, compatible with various GIS tools.",
    devCenterRouteTypes: "Car/Public Transit/Walking Routes",
    devCenterRouteTypesDesc: "Provides optimal routes for various modes of transportation.",
    devCenterTrafficInfo: "Real-time Traffic Information",
    devCenterTrafficInfoDesc: "Suggests the fastest route by reflecting real-time traffic conditions.",
    devCenterWaypoints: "Multiple Waypoints Support",
    devCenterWaypointsDesc: "Can calculate routes passing through multiple waypoints.",
    devCenterRouteDetails: "Estimated Time/Distance",
    devCenterRouteDetailsDesc: "Provides estimated travel time and distance information for each route.",
    devCenterGeocoding: "Address Search (Geocoding)",
    devCenterGeocodingDesc: "Returns coordinates for the entered address.",
    devCenterReverseGeocoding: "Coordinate → Address Conversion (Reverse Geocoding)",
    devCenterReverseGeocodingDesc: "Returns address information for the entered coordinates.",
    devCenterPOI: "POI (Point of Interest) Search",
    devCenterPOIDesc: "You can search for various points of interest such as restaurants, gas stations, and convenience stores.",
    devCenterMapAPIUse: "documentation for more detailed features.",
    devCenterSpatialAPIUse: "to utilize administrative district data.",
    devCenterRoutingAPIUse: "to add route search functionality.",
    devCenterSearchAPIUse: "to implement address search functionality.",
  }
};

